import OpenApiConfiguration from 'api/OpenApiConfiguration';
import { useQuery } from 'react-query';

import { AccountApi } from 'swagger/apis/account-api';
import { useShowAdminView } from './useAdminView';

const accountApi = new AccountApi(OpenApiConfiguration);

export default function useInboxUnreadCount() {
  const showAdminView = useShowAdminView();

  const { data: { data: inboxCount = {} } = {}, ...others } = useQuery(
    'userInboxCount',
    () => accountApi.domesticV2MeInboxCountGet(),
    { enabled: !showAdminView }
  );

  return { inboxCount, ...others };
}
